export function loadNearViewport(selector, load, rootMargin = '800px 0px') {
  const elements = document.querySelectorAll(selector);

  if (!elements.length) return;

  if (!('IntersectionObserver' in window)) {
    load();
    return;
  }

  const observer = new window.IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;

    observer.disconnect();
    load();
  }, { rootMargin });

  elements.forEach((element) => observer.observe(element));
}
